import { RawCompanyModel } from "../company_model.js";

class RawAdminCompanyModel extends RawCompanyModel {

}
const AdminCompanyModel = new RawAdminCompanyModel();

export { RawAdminCompanyModel, AdminCompanyModel }

